/** Fachsprachprüfung status — Docia only. */
export enum SpecializedLanguageExam {
  Yes = 'yes',
  No = 'no',
  Planned = 'planned',
}

export const SPECIALIZED_LANGUAGE_EXAM_I18N: Record<SpecializedLanguageExam, string> = {
  [SpecializedLanguageExam.Yes]: 'Ja',
  [SpecializedLanguageExam.No]: 'Nein',
  [SpecializedLanguageExam.Planned]: 'Geplant',
};
